import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { validateJson } from '../../../utils/jsonschema/validator';
import { assetsPackageRequestDataSuccess, assetsPackageRequestListDataSuccess } from '../../slices/assetsPackage/assetsPackage';
import imagePreload from '../../../utils/imagePreload';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import HTTP from '../../../utils/httpMethods';
import { getTimeout } from '../../api/services/utils/timeout';
var endpoint = Endpoints.ASSETS;
export var getAssetsPackageQuery = {
  query: function query(_ref) {
    var assetsPackageId = _ref.assetsPackageId;
    return {
      url: "".concat(endpoint, "/").concat(assetsPackageId),
      body: {
        timeout: getTimeout(Endpoints.ASSETS, HTTP.GET)
      }
    };
  },
  providesTags: ['AssetsPackage'],
  transformResponse: function transformResponse(response) {
    if (validateJson(endpoint, response)) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, _ref2) {
      var dispatch, queryFulfilled, getState, _yield$queryFulfilled, data, assetsByCategory;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled, getState = _ref2.getState;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;
              dispatch(assetsPackageRequestDataSuccess(data.assetsPackage));
              assetsByCategory = getState().assetsPackage.assets[data.assetsPackage.assetsPackageCategory];
              _context.next = 10;
              return imagePreload(assetsByCategory, data.assetsPackage);

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              handleQueryLoggerEvents(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var getAssetsPackageListQuery = {
  query: function query(_ref3) {
    var assetsPackageIds = _ref3.assetsPackageIds;
    return {
      url: "".concat(endpoint, "/packages?packageIds=").concat(assetsPackageIds)
    };
  },
  providesTags: ['AssetsPackage'],
  transformResponse: function transformResponse(response) {
    if (validateJson(endpoint, response)) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, _ref4) {
      var dispatch, queryFulfilled, getState, _yield$queryFulfilled2, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref4.dispatch, queryFulfilled = _ref4.queryFulfilled, getState = _ref4.getState;
              _context3.prev = 1;
              _context3.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled2 = _context3.sent;
              data = _yield$queryFulfilled2.data;
              dispatch(assetsPackageRequestListDataSuccess(data.assetsPackagesMap));
              Object.values(data.assetsPackagesMap).forEach( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(assets) {
                  var assetsByCategory;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          assetsByCategory = getState().assetsPackage.assets[assets.assetsPackageCategory][assets.assetsPackageId];
                          _context2.t0 = assetsByCategory;

                          if (!_context2.t0) {
                            _context2.next = 5;
                            break;
                          }

                          _context2.next = 5;
                          return imagePreload(assetsByCategory, assets);

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
              handleQueryLoggerEvents(_context3.t0);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 10]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};